"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactMaskinput = _interopRequireDefault(require("react-maskinput"));

var _inputs = require("../../styles/inputs");

var _containers = require("../containers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/*
    Authors' note (SPV)
    additional reference:
    https://www.npmjs.com/package/react-text-mask
    https://www.npmjs.com/package/react-maskinput
    PS: we're using maskinput but text mask will work too.
    Styled components are currently not working for text mask we had to do a workaround.
*/


var CustomMaskedInput = function CustomMaskedInput(_ref) {
  var mask = _ref.mask,
      placeholder = _ref.placeholder,
      id = _ref.id,
      flex = _ref.flex,
      width = _ref.width,
      label = _ref.label,
      _ref$labelTextProps = _ref.labelTextProps,
      labelTextProps = _ref$labelTextProps === void 0 ? {} : _ref$labelTextProps,
      _ref$maskChar = _ref.maskChar,
      maskChar = _ref$maskChar === void 0 ? "_" : _ref$maskChar,
      defaultValue = _ref.defaultValue,
      value = _ref.value,
      error = _ref.error,
      _ref$footerTextProps = _ref.footerTextProps,
      footerTextProps = _ref$footerTextProps === void 0 ? {} : _ref$footerTextProps,
      footerText = _ref.footerText,
      _onChange = _ref.onChange,
      inputProps = _objectWithoutPropertiesLoose(_ref, ["mask", "placeholder", "id", "flex", "width", "label", "labelTextProps", "maskChar", "defaultValue", "value", "error", "footerTextProps", "footerText", "onChange"]);

  var wrapperRef = (0, _react.useRef)(null);
  return /*#__PURE__*/_react["default"].createElement(_inputs.InputContainer, {
    ref: wrapperRef,
    width: width,
    flex: flex
  }, /*#__PURE__*/_react["default"].createElement(_inputs.InputLabel, labelTextProps, label), /*#__PURE__*/_react["default"].createElement(_inputs.ScaledBox, null, /*#__PURE__*/_react["default"].createElement(_containers.FlexRow, {
    width: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_inputs.MaskedInputBox, _extends({
    error: error
  }, inputProps), /*#__PURE__*/_react["default"].createElement(_reactMaskinput["default"], _extends({
    placeholder: placeholder,
    alwaysShowMask: true,
    maskChar: maskChar,
    mask: mask,
    defaultValue: defaultValue,
    value: value,
    onChange: function onChange(event) {
      var thisValue = event.target.value;

      _onChange(event);
    }
  }, inputProps)))), (error || footerText) && /*#__PURE__*/_react["default"].createElement(_inputs.InputFooterText, _extends({
    error: error
  }, footerTextProps), error ? error : footerText)));
};

var _default = CustomMaskedInput;
exports["default"] = _default;
module.exports = exports["default"];